import type { Content } from '@unifyapps/defs/blocks/Button/types';
import type { BlockTooltipAddOn } from '@unifyapps/defs/blocks/common/tooltipTypes';

/**
 * Buttons saved before the tooltip add-on redesign kept their tooltip at
 * `addOns.buttonTooltip = { content }`. New writes go to `addOns.tooltip`. When only the
 * legacy value is present, surface it as a text tooltip so those buttons keep rendering it.
 */
export function normalizeButtonTooltip(
  addOns: Content['addOns'] | undefined,
): BlockTooltipAddOn | undefined {
  const tooltip = addOns?.tooltip;

  if (tooltip?.type !== undefined || tooltip?.content !== undefined) {
    return tooltip;
  }

  const legacyContent = addOns?.buttonTooltip?.content;
  if (legacyContent) {
    return { type: 'text', content: legacyContent };
  }

  return tooltip;
}
